import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { FormattedText, Loader, Typography } from 'src/modules/core/components'
import { useMeetLink } from 'src/modules/meet/hooks'
import classes from './meet-redirect.module.scss'

export function MeetRedirect() {
  const { code } = useParams()
  const meetLink = useMeetLink(code)
  const targetUrl = meetLink.data?.url

  useEffect(() => {
    if (targetUrl) {
      // replace, not assign, so Back does not land on this redirect page again
      window.location.replace(targetUrl)
    }
  }, [targetUrl])

  const failed = !code || meetLink.isError || (meetLink.isSuccess && !targetUrl)

  return (
    <div className={classes.root}>
      {failed ? (
        <Typography variant="body" className={classes.text}>
          <FormattedText id="meet.unavailable" />
        </Typography>
      ) : (
        <Loader isLoading full />
      )}
    </div>
  )
}
